import {onFind} from "@elements/init-modules-in-scope";
import {addClass} from "@elements/dom-utils";

export function init () {
    onFind('.wysiwyg table', function (table) {
        let wrapper = document.createElement('div');

        addClass('table-responsive', wrapper);

        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
        addClass('table', table);
    });
}